<template>
    <a-modal :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
             :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose" class="single-spa-vue">
        <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
            <!--可编辑区域 start-->
            <div class="hidden">
                <a-form-item label="undefined" name="id">
                    <a-input v-model:value="form.id" placeholder="请输入undefined"/>
                </a-form-item>
            </div>
            <a-form-item label="父级菜单" name="superId">
                <tree-single-select
                    v-model:value="form.superId"
                    :options="plist"
                    title-field="name"
                    value-field="id"
                    parent-field="superId"
                    root-value="1628606141145972737"
                />
            </a-form-item>
            <a-form-item label="分组名称" name="name">
                <a-input v-model:value="form.name" placeholder="请输入分组名称"/>
            </a-form-item>
            <a-form-item label="分组编号" name="number">
                <a-input v-model:value="form.number" placeholder="请输入分组编号"/>
            </a-form-item>
            <a-form-item label="描述" name="remark">
                <a-textarea v-model:value="form.remark" placeholder="请输入描述" :auto-size="{minRows:3,maxRows:6}"/>
            </a-form-item>
            <a-form-item label="排序" name="sort">
                <a-input-number v-model:value="form.sort" :min="0" :precision="0"/>
            </a-form-item>
            <a-form-item label="是否启用" name="enabled">
                <switch-input v-model:value="form.enabled"/>
            </a-form-item>
            <!--可编辑区域 end-->
        </a-form>
    </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {sys_dict_group_controller} from "@/api/adminService";

export default {
    name: "AddOrEditGroup",
    mixins: [formMixin],
    props: {
        plist: {
            type: Array,
            default() {
                return []
            }
        }
    },
    components: {},
    data() {
        return {
            form: {
                id: null,
                superId: null,
                name: null,
                number: null,
                remark: null,
                sort: null,
                enabled: null,
            },
            rules: {
                id: [],
                superId: [
                    dataCheck.required({})
                ],
                name: [
                    dataCheck.required({}),
                ],
                number: [
                    dataCheck.required({}),
                ],
                remark: [],
                sort: [],
                enabled: [],
            },
            submitUrl: sys_dict_group_controller.saveOrUpdate
        }
    },
    methods: {},
}
</script>
<style scoped lang="less">
</style>
